import dbc from '@/api/list/tableList';

const queryList = {
  namespaced: true,
  state: {
    queryList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
  },

  actions: {
    /**
     * 获取
     * @param {*} store
     * @param {*} param
     */
    getQueryList(context, param) {
      return dbc.getQueryList(param).then(content => content.page);
    },
  },

  mutations: {
    setQueryList(state, content) {
      const { list, pageNum, total } = content.page;
      state.queryList.list = list;
      state.queryList.pageNum = pageNum;
      state.queryList.total = total;
    },
  },
};

export default queryList;
